import _objectWithoutProperties from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["index", "slides"],
    _excluded2 = ["carousel", "animation", "render", "toolbar", "controller", "on", "plugins"],
    _excluded3 = ["carousel", "animation", "render", "toolbar", "controller", "on"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from "react";
import { LightboxDefaultProps } from "./props.js";
import { CarouselModule, ControllerModule, CoreModule, createNode, NavigationModule, NoScrollModule, PortalModule, ToolbarModule, withPlugins } from "./core/index.js";

function renderNode(node, props) {
  var _a;

  return React.createElement(node.module.component, _objectSpread({
    key: node.module.name
  }, props), (_a = node.children) === null || _a === void 0 ? void 0 : _a.map(function (child) {
    return renderNode(child, props);
  }));
}

function fixupIndex(_ref) {
  var index = _ref.index,
      slides = _ref.slides,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _objectSpread({
    index: index >= 0 && index < slides.length ? index : 0,
    slides: slides
  }, rest);
}

export function Lightbox(props) {
  var carousel = props.carousel,
      animation = props.animation,
      render = props.render,
      toolbar = props.toolbar,
      controller = props.controller,
      on = props.on,
      plugins = props.plugins,
      restProps = _objectWithoutProperties(props, _excluded2);

  var defaultCarousel = LightboxDefaultProps.carousel,
      defaultAnimation = LightboxDefaultProps.animation,
      defaultRender = LightboxDefaultProps.render,
      defaultToolbar = LightboxDefaultProps.toolbar,
      defaultController = LightboxDefaultProps.controller,
      defaultOn = LightboxDefaultProps.on,
      restDefaultProps = _objectWithoutProperties(LightboxDefaultProps, _excluded3);

  var _withPlugins = withPlugins([createNode(PortalModule, [createNode(NoScrollModule, [createNode(ControllerModule, [createNode(CarouselModule), createNode(ToolbarModule), createNode(NavigationModule)])])])], plugins, [fixupIndex]),
      config = _withPlugins.config,
      augmentation = _withPlugins.augmentation;

  var augmentedProps = augmentation(_objectSpread(_objectSpread({
    carousel: _objectSpread(_objectSpread({}, defaultCarousel), carousel),
    animation: _objectSpread(_objectSpread({}, defaultAnimation), animation),
    render: _objectSpread(_objectSpread({}, defaultRender), render),
    toolbar: _objectSpread(_objectSpread({}, defaultToolbar), toolbar),
    controller: _objectSpread(_objectSpread({}, defaultController), controller),
    on: _objectSpread(_objectSpread({}, defaultOn), on)
  }, restDefaultProps), restProps));
  if (!augmentedProps.open) return null;
  return React.createElement(React.Fragment, null, renderNode(createNode(CoreModule, config), augmentedProps));
}